<div class="right-panel-view" *ngIf="profileView">
  <h2 class="profile-title">{{ 'AUTHORIZATION.MY_ACCOUNT' | translate }}</h2>
  <div class="profile-container">
    <img class="profile-image" src="assets/img/icons/profile-image.png" />
    <h2 class="profile-username">{{userDetails?.name}}</h2>
    <p class="profile-user-name">{{ role |translate }}</p>

    <mat-select [(ngModel)]="institutionNameShow" (selectionChange)="insChange($event)"
      class="readonly-block select-container profile-institution-selector" placeholder="Select institution"
      *ngIf='!isPlatform && institutionList?.length > 1 && !isSuperAdminOrCountryAdmin'>
      <mat-option *ngFor="let institution of institutionList" [value]="institution.id">
        {{institution.label}}</mat-option>
    </mat-select>

    <p *ngIf='!isPlatform && institutionList?.length == 1 && !isSuperAdminOrCountryAdmin' class="profile-user-name">{{institutionList[0]?.label}}</p>

    <div class="mt-4" *ngIf="profileUrl">
      <p class="mb-2 mt-2 text-left profile-url" (click)="redirectToProfile(0)">
        {{ translationKeys.UserProfiles.ProfileDetails | translate }}</p>
      <mat-divider></mat-divider>
      <p class="mb-2 mt-2 text-left profile-url" (click)="redirectToProfile(5)" *ngIf="isNotHartmannUser">
        {{ translationKeys.UserProfiles.ChangePassword | translate }}</p>
      <mat-divider></mat-divider>
    </div>

    <div class="container mt-2 p-0 profile-signout">
      <button (click)="logout()" class="btn-bd expand-button">
        {{ translationKeys.UserProfiles.Signout | translate }}</button>
    </div>
  </div>
</div>